import { Component } from 'react';
import { Link } from "react-router-dom";
import { getImageUrl } from '../../../config/api';

const defaultLogo = (typeof process.env.PUBLIC_URL === 'string' ? process.env.PUBLIC_URL : '') + '/images/logo@2x.png';

class BoxPost extends Component {
    render() {
        const { member } = this.props;
        if (!member) return null;

        const imageSrc = getImageUrl(member.image) || defaultLogo;
        const description = member.bio ? (member.bio.length > 120 ? member.bio.slice(0, 120).trim() + '…' : member.bio) : '';
        const role = member.subtitle || member.title;

        return (
            <article className="modern-profile-card">
                <Link to={`/team/${member.id}`} className="modern-profile-avatar" title={`View ${member.name}'s profile`}>
                    <img
                        src={imageSrc}
                        alt={member.name}
                        onError={(e) => { e.target.src = defaultLogo; }}
                    />
                </Link>
                <div className="modern-profile-body">
                    {role && <span className="modern-profile-role">{role}</span>}
                    <h3>
                        <Link to={`/team/${member.id}`}>{member.name}</Link>
                    </h3>
                    {description && <p>{description}</p>}
                    <div className="modern-profile-socials">
                        {member.email && (
                            <a href={`mailto:${member.email}`} title={`Email ${member.name}`}>
                                <i className="fa fa-envelope" aria-hidden="true"></i>
                            </a>
                        )}
                        {member.linkedin && (
                            <a href={member.linkedin} title={`LinkedIn ${member.name}`} target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-linkedin" aria-hidden="true"></i>
                            </a>
                        )}
                        {member.twitter && (
                            <a href={member.twitter} title={`Twitter ${member.name}`} target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-twitter" aria-hidden="true"></i>
                            </a>
                        )}
                    </div>
                </div>
            </article>
        )
    }
}

export default BoxPost;
